module.exports = __webpack_public_path__ + "static/media/Observer.9c3a49d5.svg";